import { Category } from "@domain/lms/category/category";
import { ContentLanguage } from "@domain/lms/contentLanguage";
import { Carousel } from "./carousel";

export interface CarouselPostInfos {
	category: Category | undefined;
	title: string;
	language: ContentLanguage | string;
}

export interface CarouselDto {
	isCarrousel: boolean;
	title?: string;
	category?: Category;
	language?: ContentLanguage;
}

export const carouselFromDto = (carousel: Carousel): Carousel => {
	return {
		...carousel,
		contentType: "CAROUSEL",
	};
};
